// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import Checkbox from '../inputs/Checkbox';
import NoDataCell from './NoDataCell';

// Utils
import { formatMessage } from '../../../utils/i18n';

type Props = {
  value: boolean | string;
  checkboxOptions: any;
  className?: string;
  onClick?: () => void;
  id?: string;
};

const isSelected = (value: boolean | string): boolean => (typeof value === 'string' ? value === 'Yes' : value);

const CheckboxCell: React.FunctionComponent<Props> = ({ value, checkboxOptions, className, onClick, id }: Props) => {
  if (value == null) {
    return <NoDataCell onClick={onClick} id={id} />;
  }

  const state = isSelected(value);
  return (
    <div
      className={classNames(className, 'cell checkbox-cell d-flex justify-content-center', { checked: state })}
      id={id ? `cell-${id}` : undefined}
      onClick={onClick}
    >
      <span className="markup-container">
        <Checkbox selected={state} label={formatMessage(checkboxOptions[state.toString()])} />
      </span>
    </div>
  );
};

export default CheckboxCell;
